<template>
    <li>
        <div
           :class="isComplete ? 'bg-green-50' : ''"
           class="block text-gray-700 hover:bg-gray-50 focus:outline-none focus:bg-gray-50">
            <div class="px-4 py-4 sm:px-6">
                <div class="flex items-center justify-between">
                    <div class="text-sm font-medium leading-5 truncate">
                        <span class="pr-0 lnr icon-database-history sm:pr-2"></span>
                        <span class="text-blue-600">{{deviceType}}</span>
                        <span v-if="isGateway || isHub" class="px-2 py-1 ml-4 text-sm font-bold leading-4 text-red-800 bg-red-100 rounded-full">Connect First!</span>
                    </div>
                    <div class="flex shrink-0 ml-2">
                      <span v-if="totalCheckins" class="inline-flex px-2 text-xs font-semibold leading-5 text-green-800 bg-green-100 rounded-full">
                          Checked In!
                      </span>
                      <span v-else-if="!hasLoaded" class="inline-flex px-2 text-xs font-semibold leading-5 text-gray-800 bg-gray-100 rounded-full">
                          Loading...
                      </span>
                      <span v-else class="inline-flex px-2 text-xs font-semibold leading-5 text-yellow-800 bg-yellow-100 rounded-full">
                          Waiting for check-in!
                      </span>
                    </div>
                </div>
                <div class="mt-2 sm:flex sm:justify-between">
                    <div class="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2">
                        <div class="col-span-1 flex items-center mr-6 text-sm leading-5 text-gray-500">
                            <span class="pr-2 lnr icon-license"> </span>
                            {{holding.serial}}
                        </div>
                        <div class="col-span-1">
                            <div v-if="isWifi"
                                 class="flex items-center mt-2 text-sm leading-5 text-gray-500 sm:mt-0">
                                <span class="pr-2 lnr icon-wifi"> </span>
                                Wifi
                            </div>
                            <div v-if="isCell"
                                 class="flex items-center mt-2 text-sm leading-5 text-gray-500 sm:mt-0">
                                <span class="pr-2 lnr icon-phone-wave"></span>
                                Cell
                            </div>
                            <div v-if="isEthernet"
                                 class="flex items-center text-sm leading-5 text-gray-500">
                                <span class="pr-2 lnr icon-cable"></span>
                                Ethernet
                            </div>
                            <div v-if="is900"
                                 class="flex items-center text-sm leading-5 text-gray-500">
                                <span class="pr-2 lnr icon-antenna"></span>
                                900 MHz
                            </div>
                            <div v-if="isSoniLink"
                                 class="flex items-center text-sm leading-5 text-gray-500">
                                <span class="pr-2 lnr icon-link"></span>
                                SoniLink
                            </div>
                        </div>
                    </div>
                    <div v-if="totalCheckins" class="flex items-center mt-2 text-sm leading-5 text-gray-500 sm:mt-0">
                        <span class="lnr icon-clipboard-check"></span>
                        <span v-if="totalCheckins">
                          <template v-if="isHub">
                            Actively Connected to SoniCloud
                          </template>
                          <template v-else>
                            {{totalCheckins}} check-ins ({{lastCheckinReadable}})
                          </template>
                        </span>
                    </div>
                </div>
            </div>
<!--  This is the bottom bar for validating the checkin -->
            <div v-if="totalCheckins || isComplete" class="px-4 py-0 sm:px-6">
                <div class="flex items-center justify-between">
                    <div v-if="probeCount > 0 && !isGateway" class="text-sm font-medium leading-5 truncate">
                        Probes detected:
                    </div>
                    <div v-else class="text-sm font-medium leading-5 truncate">
                        &nbsp;
                    </div>
                    <div class="flex shrink-0 ml-2">
                        <button type="button"
                                v-if="!isComplete && !isSkipped"
                                @click="postDeviceConnectivityComplete()"
                                class="items-center hidden px-4 py-2 ml-2 font-sans leading-5 text-blue-700 border-2 border-blue-200 rounded-md sm:block text-md font-sm bg-white-600 hover:bg-blue-200 focus:outline-none focus:ring-blue-200 focus:border-blue-400 active:bg-blue-300">
                          {{ isHub ? 'Hub' : 'Device' }} is Good!
                        </button>
                        <span v-if="isComplete">Device Connected!</span>
                        <span v-if="isSkipped" class="inline-flex px-2 text-xs font-semibold leading-5 text-gray-800 bg-gray-100 rounded-full">
                          {{ isHub ? 'Hub' : 'Device' }}  Skipped
                        </span>
                    </div>
                </div>
                <!-- This bar has probe info & 'Somethings Not Right' -->
                <div class="mt-2 sm:flex sm:justify-between" >
                    <div class="text-sm sm:flex">
                      <div v-if="!isGateway && !isHub">
                        <div v-for="(numberOfProbes, probe) in probes"
                             :key="probe"
                             class="flex flex-wrap items-center mr-6 text-sm leading-5 text-gray-500 sm:flex-nowrap">
                          <span class="pr-2 lnr icon-thermometer"> </span>
                          <span>{{numberOfProbes}} {{probe}}</span>
                          <!-- We only show here on mobile -->
                          <ul class="sm:hidden">
                            <li v-for="serial in getProbeSerial(probe)"
                                class="pl-2"
                                :key="serial">
                              {{serial}}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div    :class="(isSkipped && skippedNotes) ? 'w-1/3 text-right justify-end' : 'justify-center'"
                            class="flex-wrap items-center justify-center mt-2 text-sm leading-5 text-gray-500 sm:flex sm:mt-0">
                        <button type="button"
                                v-if="!isComplete && !isSkipped"
                                @click="postDeviceConnectivityComplete()"
                                class="items-center block w-full px-4 py-2 ml-0 font-sans leading-5 text-blue-700 border-2 border-blue-200 rounded-md sm:hidden sm:w-auto sm:ml-2 text-md font-sm bg-white-600 hover:bg-blue-200 focus:outline-none focus:ring-blue-200 focus:border-blue-400 active:bg-blue-300">
                            Device is Good!
                        </button>
                        <button type="button"
                                @click="somethingIsWrong = true"
                                v-if="(!isComplete && !isSkipped) || somethingIsWrong === true"
                                class="items-center block w-full px-4 py-2 mt-2 ml-0 font-sans leading-5 text-red-700 border-2 border-red-200 rounded-md sm:mt-0 sm:w-auto sm:ml-2 text-md font-sm bg-white-600 hover:bg-red-200 focus:outline-none focus:ring-red-200 focus:border-red-400 active:bg-red-300">
                            Something's not right...
                        </button>
                        <p v-if="isSkipped && skippedNotes" class="font-sm">
                            Notes:<br/>
                            {{ skippedNotes }}
                        </p>
                    </div>
                </div>
                <!-- This has the probe IDs -->
                <div class="mt-2 sm:flex sm:justify-between" >
                    <div class="text-sm sm:flex">
                        <div v-for="(numberOfProbes, probe) in probes"
                             :key="probe"
                             class="flex flex-wrap items-center w-1/2 mr-6 text-sm leading-5 text-gray-500">
                            <!-- We only show here on desktop views -->
                            <ul class="hidden sm:block">
                                <li v-for="serial in getProbeSerial(probe)"
                                      class="pl-2"
                                      :key="serial">
                                    {{serial}}
                                </li>
                            </ul>

                        </div>
                    </div>
                    <div class="flex-wrap items-center justify-center pb-4 mt-2 text-sm leading-5 text-center text-gray-500 sm:flex sm:mt-0 sm:pb-2">
                        <span v-if="isComplete || isSkipped"
                              @click="postDeviceConnectivityReset"
                              class="pb-1 text-blue-800 border-b border-blue-800 cursor-pointer">Retry Device Connection</span>
                    </div>
                </div>
            </div>
<!--  Bar for debugging connectivity issues -->
            <div v-if="somethingIsWrong || probeNotDetected" class="px-4 py-0 sm:px-6">
                <div class="flex flex-wrap items-center justify-between">
                    <div v-if="somethingIsWrong" class="w-full text-sm font-semibold leading-5 truncate sm:py-2 sm:w-full">
                            What is the issue?
                            <ul class="list-disc font-medium mt-1">
                                <li class="mb-2" v-if="!isGateway && !isHub">
                                    <a      target="_blank"
                                            href="https://support.sonicu.com/how-to-troubleshoot-a-no-probe-error-duo">
                                        I don't see the probes I'm expecting
                                    </a>
                                </li>
                                <li class="mb-2" v-if="!isGateway && !isARC && !isHub">
                                    <a      v-if="isDuo"
                                            target="_blank"
                                            href="https://support.sonicu.com/sonishield-duo-quick-start-guide">
                                        The Duo isn't connecting
                                    </a>
                                    <a      v-if="isView"
                                            target="_blank"
                                            href="https://support.sonicu.com/sonishield-duo-quick-start-guide">
                                        The View isn't connecting
                                    </a>
                                    <a      v-else-if="!isHub"
                                            target="_blank"
                                            href="https://support.sonicu.com/mvp-410/440-quick-start-guide">
                                        The device isn't connecting
                                    </a>
                                </li>
                                <li class="mb-2" v-if="isGateway">
                                    <a      target="_blank"
                                            href="https://support.sonicu.com/mvp-gateway-quick-start-guide">
                                        The gateway isn't connecting
                                    </a>
                                </li>
                                <li class="mb-2" v-if="isHub">
                                    <a      target="_blank"
                                            href="https://support.sonicu.com/sonilink-hub-installation-guide">
                                        The hub isn't connecting
                                    </a>
                                </li>
                            </ul>
                    </div>

                    <div v-if="somethingIsWrong" class="flex flex-wrap justify-end w-full ml-2 sm:shrink-0 sm:w-full">
                            <p class="w-full text-center sm:text-left">Still having issues?<br/>Add notes and skip this device</p>
                            <textarea v-model="skippedNotes"
                                      class="w-full p-2 border"
                                      rows="4"
                                      placeholder="Add notes to mark this as skipped">
                        </textarea>
                        </div>
                    <div v-if="!somethingIsWrong" class="w-full text-sm font-medium leading-5 break-normal sm:w-1/2">
                        <a href="https://support.sonicu.com/how-to-troubleshoot-a-no-probe-error-duo">Your device has a probe that isn't fully connected; click here for support</a>
                    </div>
                </div>
                <div class="mt-2 sm:flex sm:justify-between" >
                    <div class="text-sm sm:flex">
                        <div class="flex flex-wrap items-center mr-6 text-sm leading-5 text-gray-500 sm:flex-nowrap">
                            <!-- We only show here on mobile with sm:hidden-->
                        </div>
                    </div>
                    <div class="flex-wrap items-center justify-center mt-2 text-sm leading-5 text-gray-500 sm:flex sm:mt-0">
                        <button type="button"
                                v-if="!isComplete && somethingIsWrong"
                                @click="postDeviceConnectivitySkipped"
                                class="items-center block w-full px-4 py-2 mt-2 ml-0 font-sans leading-5 text-red-700 border-2 border-red-200 rounded-md sm:mt-0 sm:w-auto sm:ml-2 text-md font-sm bg-white-600 hover:bg-red-200 focus:outline-none focus:ring-red-200 focus:border-red-400 active:bg-red-300">
                            Skip this device for now
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
    import axios from 'axios';
    import {isNil} from 'lodash'
    import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";

    export default {
        name: "InstallWizardConnectivityCard",
        mixins: [SonicuCoreMixin],
        props: {
            holding: Object,
            status: {
                type: Object,
                default: function(){
                    return {notes: '',};
                },
            },
        },
        created(){
            if(!isNil(this.status) && this.status.status === 1){
                this.hasCompletedEmit = true;
            }
            if(!isNil(this.status) && this.status.status === 2){
                this.hasSkippedEmit = true;
            }
        },
        data(){
            return {
                device: Object,
                hasLoaded: false,
                hasCheckedInEmit: false,
                hasCompletedEmit: false,
                hasSkippedEmit: false,
                somethingIsWrong: false,
                probeNotDetected: false,
                skippedNotes: !isNil(this.status) ? this.status.notes : '',
            }
        },
        mounted() {
            this.getDeviceData();
        },
        methods: {
            getDeviceData(){
                if(this.holding.serial === undefined){
                    return null;
                }
                let targetUrl = 'devices/' + this.holding.serial;
                if(this.isHub){
                  targetUrl = targetUrl + "?hub=true"
                }
                else if (this.isDisplay) {
                    targetUrl = targetUrl + "?isDisplay=true"
                }
                axios
                    .get(this.company.buildCompanyApiInternalRoute(targetUrl))
                    .then(response =>{
                        if(this.isHub){
                            this.device = response.data.data;
                            this.hasLoaded = true;
                            this.emitCheckedIn();
                            return;
                        }
                        this.device = response.data.data;
                        this.hasLoaded = true;
                        this.updateSettings();
                        this.makeGatewayCompatible();
                        this.emitCheckedIn();
                        this.setRefresh(); // Refresh this info on a set interval
                    });
            },
            getProbeSerial(probeType){
                let theseProbes = new Set();
                if(this.deviceHasPoints){
                    _.forOwn(this.device.points, function(point){
                        if(point.probe_calibrations.length > 0){
                            if(probeType === point.probe_calibrations[0].probe_type){
                                theseProbes.add(point.probe_serial);
                            }
                        }
                    });
                }
                return theseProbes;
            },
            postDeviceConnectivityComplete(){
                this.somethingIsWrong = false;
                axios
                    .put(this.company.buildCompanyApiInternalRoute('wizard/connectivity/' + this.holding.serial),
                        {type: 'complete'})
                    .then(response => {
                        this.$emit('device-completed', this.holding.serial);
                        this.hasCompletedEmit = true;
                    });
            },
            postDeviceConnectivitySkipped(){
                axios
                    .put(this.company.buildCompanyApiInternalRoute('wizard/connectivity/' + this.holding.serial),
                        {type: 'skipped', 'notes': this.skippedNotes,})
                    .then(response => {
                        this.$emit('device-skipped', this.holding.serial);
                        this.hasSkippedEmit = true;
                        this.hasCompletedEmit = false;
                        this.somethingIsWrong = false;
                    });
            },
            postDeviceConnectivityReset(){
                axios
                    .put(this.company.buildCompanyApiInternalRoute('wizard/connectivity/' + this.holding.serial),
                        {type: 'reset'})
                    .then(response => {
                        this.$emit('device-reset', this.holding.serial);
                        this.hasSkippedEmit = false;
                        this.hasCompletedEmit = false;
                        this.setRefresh();
                    });
            },
            emitCheckedIn(){
                if(this.totalCheckins >= 1 && this.hasCheckedInEmit === false){
                    this.$emit('device-checkin', this.holding.serial);
                    this.hasCheckedInEmit = true;
                }
            },
            setRefresh(){
                if(this.isComplete || this.isSkipped){
                    // Once we're complete, don't keep querying
                } else {
                    // Randomize the timeout so we're not all hitting it right at the same time except on initial load.
                    setTimeout(this.getDeviceData, _.random(35000, 55000, false));
                }
            },
            updateSettings(){
                if (this.deviceExists && !isNil(this.device.settings)) {
                    this.holding.settings = Object.assign(this.holding.settings, this.device.settings);
                }
            },
            makeGatewayCompatible(){
                // Gateways don't have points; they have diagnostic points only
                // Therefore if we have a gateway, let's set diagnostics as a point
                if(this.isGateway){
                    this.device.points = this.device.diagnostic;
                }
            },
        },
        computed: {
            isWifi(){
                return ((this.holding.settings.wifi_serial !== undefined) && this.holding.settings.wifi_serial !== 'Not Installed') && !this.isSoniLink;
            },
            isCell(){
                return ((this.holding.settings.cell_serial !== undefined) && this.holding.settings.cell_serial !== 'Not Installed');
            },
            isEthernet(){
                return ((this.holding.settings.ethernet_serial !== undefined) && this.holding.settings.ethernet_serial !== 'Not Installed');
            },
            is900(){
                return ((this.holding.settings.serial_900 !== undefined) && this.holding.settings.serial_900 !== 'Not Installed');
            },
            isSoniLink(){
                return ((this.holding.settings.sonilink_serial !== undefined) && this.holding.settings.sonilink_serial !== 'Not Installed');
            },
            isGateway(){
                return this.deviceType.includes('Gateway');
            },
            isDuo() {
                return this.deviceType.includes('SoniShield Duo')
            },
            isView() {
                return this.deviceType.includes('SoniShield View')
            },
            isARC(){
                return this.deviceType.includes('ARC');
            },
            isHub(){
                return this.deviceType.includes('SoniLink Hub');
            },
            isDisplay(){
                return this.deviceType.includes('SoniShield Display');
            },
            isComplete(){
                return this.hasCompletedEmit === true;
            },
            isSkipped(){
                return this.hasSkippedEmit === true;
            },
            deviceExists() {
                console.log(_.isNil(this.device))
                return !isNil(this.device)
            },
            deviceHasPoints() {
                return this.deviceExists && !isNil(this.device.points)
            },
            deviceType(){
                if((this.holding.settings.device_type !== undefined) && this.holding.settings.device_type !== 'Not Installed'){
                    return this.holding.settings.device_type;
                } else {
                    return 'Unknown Device Type';
                }
            },
            lastCheckinReadable(){
                let lastCheckinUnix = 0;
                let lastCheckinReadable = '';
                if(this.deviceHasPoints){
                    if(this.device.points.length > 0){
                        this.device.points.forEach(function (point){
                            if(point.lastCheckin !==null && point.lastCheckin.Time > lastCheckinUnix){
                                lastCheckinUnix = point.lastCheckin.Time;
                                lastCheckinReadable = point.lastCheckinReadable;
                            }
                        });
                    }
                }
                return lastCheckinReadable;
            },
            totalCheckins(){
                let totalCheckinCount = 0;
                if(this.deviceHasPoints){
                    if(this.device.points.length > 0){
                        this.device.points.forEach(function (point){
                            totalCheckinCount += point.totalCounts;
                        })
                    }
                }
                // Ensure we don't have a noprobe
                if (totalCheckinCount === 0 && this.deviceHasPoints) {
                    this.device.points.forEach((point) => {
                        if (!isNil(point.meter)) {
                            if(!isNil(point.meter.LastUpdateDB) && point.meter.LastUpdateDB.length > 0){
                                if(point.meter.LastUpdateDB.includes('No Probe')){
                                    this.probeNotDetected = true;
                                }
                            }
                        }
                    })
                } else {
                    this.probeNotDetected = false;
                }
                return totalCheckinCount;
            },
            probes(){
                let theseProbes = {};
                if(this.isHub){
                  return theseProbes;
                }
                let probeSerials = new Set;
                if(this.deviceHasPoints){
                    _.forOwn(this.device.points, function(point, key){
                        let probeType = 'No Probe';
                        if(point.probe_serial !== ''){
                          probeType = 'Unidentified Probe'
                        }
                        if(point.probe_calibrations.length > 0){
                            probeType = point.probe_calibrations[0].probe_type;

                            // Set the internal/external HT probes to not be reading specific (remove the Temp/Humidity)
                            if(probeType.includes('Internal HT')){
                                probeType = 'Internal HT';
                            }
                            if(probeType.includes('External HT')){
                                probeType = 'External HT';
                            }
                            if(probeType.includes('SoniShield HT')) {
                                probeType = 'SoniShield HT'
                            }
                        }
                        let probeSerial = point.probe_serial;
                        if(!probeSerials.has(probeSerial)){
                            probeSerials.add(probeSerial);
                            if(theseProbes[probeType] === undefined){
                                theseProbes[probeType] = 1;
                            } else {
                                let serialExists = false
                                probeSerials.forEach(serial => {
                                    if (probeSerial.substr(2) === serial.substr(2)) {
                                        serialExists = true
                                    }
                                })
                                if (!serialExists) {
                                    theseProbes[probeType] += 1;
                                }
                            }
                        }
                    });
                }
                return theseProbes;
            },
            probeCount(){
                return _.size(this.probes);
            },
        },
    }
</script>

<style scoped>

</style>